import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, Link, Typography} from '@material-ui/core';
import {
    SelectInput,
    TextInput
} from 'react-admin';
import AgentAPI from './AgentAPI';

const agentUrl = 'https://cipher.kiev.ua/files/pcs/jnlp/pcs-dev-preview.jnlp';

const HardwareSignComponent = props => {
    React.useEffect(() => {
        const interval = setInterval(() => {AgentAPI.checkStatus()}, 2000);
        return () => clearInterval(interval);
    });

    if (props.onMounted) {
        props.onMounted({
            verify: AgentAPI.verifyKey,
            sign: AgentAPI.signString,
            started: localStorage.getItem('started')
        });
    }

    return (
        <div style={{align: 'left', width: '100%'}}>
            <div style={{align: 'left', width: '100%'}}>
                {localStorage.getItem('started') ? null :
                    <Button
                        color="primary"
                        variant="outlined"
                        style={{clear: 'both', marginBottom: '20px'}}
                        onClick={() => {window.location = agentUrl;}}
                    >
                        Увімкнути агент
                    </Button>}

                {localStorage.getItem('started')
                    ? <Typography variant="subtitle1" style={{color: '#22aa22'}}>підключено</Typography>
                    : <Typography variant="subtitle1" style={{marginLeft: '20px'}}>не підключено</Typography>}
            </div>

            <SelectInput
                resettable={true}
                label="КНЕДП *"
                className="digital-signature"
                formClassName="tab-content-item"
                source="ca"
                choices={JSON.parse(localStorage.getItem('caList')) || []}
            />

            <SelectInput
                id="sign-type"
                style={{marginLeft: '20px'}}
                resettable={true}
                label="Тип ключа *"
                className="digital-signature"
                formClassName="tab-content-item"
                source="signType"
                choices={[
                    {id: 'activeTokenPath', name: 'PKCS#11 пристрій - активний режим'},
                    {id: 'passiveTokenPath', name: 'PKCS#11 пристрій - пасивний режим'}
                ]}
                onChange={(event) => {
                    let list = [];
                    let keyData = JSON.parse(localStorage.getItem('keyData'));

                    if (event.target?.value && keyData[event.target?.value]) {
                        for (let i = 0; i < keyData[event.target.value].length; i++) {
                            list[i] = {id: keyData[event.target.value][i], name: keyData[event.target.value][i]}
                        }
                    }

                    localStorage.setItem('keyList', JSON.stringify(list));
                }}
            />

            <SelectInput
                resettable={true}
                label="Шлях до контейнеру *"
                className="digital-signature"
                formClassName="tab-content-item"
                source="signPath"
                choices={JSON.parse(localStorage.getItem('keyList')) || []}
            />

            <TextInput
                style={{marginLeft: '20px'}}
                type={"password"}
                className="digital-signature-password tab-content-item"
                source={"password2"}
                label={"Пароль ЕЦП *"}
            />
        </div>
    );
};

export default HardwareSignComponent;
